import styled from 'styled-components';

export const TabContainer = styled.div`
  min-height: 50vh;
`;

export const Section = styled.div`
  margin-bottom: 3rem;
  
  h2 {
    font-size: 1.8rem;
    margin-bottom: 1.5rem;
    color: var(--primary-color);
    text-align: center;
    
    @media (max-width: 768px) {
      font-size: 1.5rem;
    }
  }
  
  h3 {
    font-size: 1.4rem;
    margin: 1.5rem 0 1rem;
    color: var(--dark-blue);
    
    @media (max-width: 768px) {
      font-size: 1.2rem;
    }
  }
  
  p {
    margin-bottom: 1rem;
    line-height: 1.6;
    
    @media (max-width: 768px) {
      font-size: 0.95rem;
    }
  }
  
  ul {
    padding-left: 1.5rem;
    margin-bottom: 1rem;
  }
  
  li {
    margin-bottom: 0.5rem;
    line-height: 1.6;
    
    @media (max-width: 768px) {
      font-size: 0.95rem;
    }
  }
`;

export const SectionDescription = styled.p`
  text-align: center;
  color: var(--text-color);
  font-size: 1.1rem;
  margin: -0.5rem 0 2rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  
  @media (max-width: 768px) {
    font-size: 1rem;
    margin: -0.25rem 0 1.5rem;
  }
`; 